export default __webpack_public_path__ + "static/media/DocCallOffIcon.81414f04.svg";